import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { generarDesafioTcooAction } from '../../../../application/actions/generarDesafioTcoo';


import api from '../../../api';
const apiGenerarDesafioTcoo = api(process.env.REACT_APP_URL);

export function* fetchGenerarTcco(params) {
  try {
    
    const { autorizacion, trackid } = params.payload;

    const { data } = yield call(apiGenerarDesafioTcoo.post,'/desafio/coordenadas/solicitar', '' , { 
      'Track-Id': trackid,
      'Authorization': autorizacion
     });


    if (data) {
      yield put(generarDesafioTcooAction.fetchGenerarTcooSuccess({ respuestaServicio: data }));
    } else {
      yield put(generarDesafioTcooAction.fetchGenerarTcooError());

    }

  } catch {
      //Errores
    yield all([
      put(generarDesafioTcooAction.fetchGenerarDesafioTcooError())
    ]);
  }
}

export function* watchFetchGenerarTcco() {
  yield takeLatest(generarDesafioTcooAction.fetchGenerarTcoo.type, fetchGenerarTcco);
}

export default function* rootSaga() {
  yield spawn(watchFetchGenerarTcco);
}
